import { initializeApp } from "https://www.gstatic.com/firebasejs/10.12.1/firebase-app.js";
import { getAuth, signInWithPopup, GoogleAuthProvider, onAuthStateChanged, createUserWithEmailAndPassword, signInWithEmailAndPassword, EmailAuthProvider, reauthenticateWithCredential, reauthenticateWithPopup, updatePassword, deleteUser, signOut, sendPasswordResetEmail, signInWithCredential } from "https://www.gstatic.com/firebasejs/10.12.1/firebase-auth.js";
import { getFirestore, doc, getDoc, setDoc, query, where, collection, collectionGroup, getDocs, deleteDoc, updateDoc, onSnapshot, getDocFromServer, limit, deleteField, addDoc, serverTimestamp } from "https://www.gstatic.com/firebasejs/10.12.1/firebase-firestore.js";
import { getFunctions, httpsCallable } from "https://www.gstatic.com/firebasejs/10.12.1/firebase-functions.js";

const _getAppSecret = () => window._getAppSecret();

const firebaseConfig = {
    apiKey: "AIzaSyAu143AS-fe8zeDkrEGKI2nlsVHQlCPBT0",
    authDomain: "qrbloomsuite.com",
    projectId: "qr-bloom-professional-suite",
    storageBucket: "qr-bloom-professional-suite.firebasestorage.app",
    messagingSenderId: "642784248397",
    appId: "1:642784248397:web:baaa356236ae3b76159204",
    measurementId: "G-RBP6LTKKFE"
};

const app = initializeApp(firebaseConfig);
const auth = getAuth(app);
const db = getFirestore(app);
const functions = getFunctions(app, 'us-central1');

async function detectLocation() {
    try {
        const res = await fetch('https://get.geojs.io/v1/ip/geo.json');
        if (!res.ok) throw new Error('geojs failed');
        const data = await res.json();
        if (data && data.city) {
            const parts = [];
            if (data.city && data.city !== '-') parts.push(data.city);
            if (data.region && data.region !== '-') parts.push(data.region);
            if (data.country && data.country !== '-') parts.push(data.country);
            return parts.join(', ');
        }
    } catch (e) {
        console.warn("geojs failed, trying ipapi.co", e.message);
        try {
            const res = await fetch('https://ipapi.co/json/');
            if (!res.ok) throw new Error('ipapi.co failed');
            const text = await res.text();
            const data = JSON.parse(text);
            if (data && data.city) {
                const parts = [];
                if (data.city) parts.push(data.city);
                if (data.region) parts.push(data.region);
                if (data.country_name) parts.push(data.country_name);
                return parts.join(', ');
            }
        } catch (e2) {
            console.warn("ipapi.co failed", e2.message);
        }
    }
    return 'Unknown Location';
}

function getCleanDeviceAndBrowser(ua) {
    if (!ua) return 'Unknown Device';
    let browser = "Browser";
    let os = "OS";

    // Detect OS
    if (/Windows/i.test(ua)) os = "Windows Platform";
    else if (/Android/i.test(ua)) os = "Android Mobile";
    else if (/iPhone|iPad|iPod/i.test(ua)) os = "iOS Device";
    else if (/Macintosh|Mac OS X/i.test(ua)) os = "MacOS Environment";
    else if (/Linux/i.test(ua)) os = "Linux Distribution";
    else os = "Corporate Workstation";

    // Detect Browser
    if (/Edg/i.test(ua)) browser = "Microsoft Edge";
    else if (/Chrome/i.test(ua)) browser = "Google Core";
    else if (/Firefox/i.test(ua)) browser = "Red Fox Architecture";
    else if (/Safari/i.test(ua)) browser = "Safari";
    else browser = "Software Suite";

    return `${browser} on ${os}`;
}

function formatLoginTimeClient(date = new Date()) {
    const months = ["JAN", "FEB", "MAR", "APR", "MAY", "JUN", "JUL", "AUG", "SEP", "OCT", "NOV", "DEC"];
    const kolkataDate = new Date(date.toLocaleString("en-US", { timeZone: "Asia/Kolkata" }));
    const month = months[kolkataDate.getMonth()];
    const day = kolkataDate.getDate();
    const year = kolkataDate.getFullYear();

    let hours = kolkataDate.getHours();
    const minutes = String(kolkataDate.getMinutes()).padStart(2, '0');
    const ampm = hours >= 12 ? 'PM' : 'AM';
    hours = hours % 12;
    hours = hours ? hours : 12;

    return `${month} ${day} , ${year} AT ${hours}:${minutes} ${ampm} IST`;
}

const ownerEmails = ['pramodchandrabajpai@gmail.com', 'support.fusionforge@gmail.com'];
let isSettingsSyncPending = false;
let settingsSyncTimeout = null;

const FONT_MAP = {
    "1": "Space Grotesk",
    "2": "Montserrat",
    "3": "Inter",
    "4": "Lato",
    "5": "Merriweather",
    "6": "Lora",
    "7": "Clash Display",
    "8": "Bricolage Grotesque"
};

const REVERSE_FONT_MAP = {
    "Space Grotesk": "1",
    "Montserrat": "2",
    "Inter": "3",
    "Lato": "4",
    "Merriweather": "5",
    "Lora": "6",
    "Clash Display": "7",
    "Bricolage Grotesque": "8"
};

// Export for Debugging
window.suiteAuth = auth;
window.suiteApp = app;
window.suiteDb = db;
window.suiteDoc = doc;
window.suiteGetDoc = getDoc;
window.suiteUpdateDoc = updateDoc;
window.suiteDeleteField = deleteField;
window.suiteFunctions = functions;
window.suiteSetDoc = setDoc;
window.suiteGetDocs = getDocs;
window.suiteCollection = collection;
window.suiteDeleteDoc = deleteDoc;
window.suiteQuery = query;
window.suiteWhere = where;
window.suiteLimit = limit;
window.suiteCollectionGroup = collectionGroup;
window.createRazorpayOrder = async (data) => {
    const createOrderFn = httpsCallable(functions, 'createRazorpayOrder');
    const res = await createOrderFn(data);
    return res.data;
};
window.verifyRazorpayPayment = async (data) => {
    const verifyPaymentFn = httpsCallable(functions, 'verifyRazorpayPayment');
    const res = await verifyPaymentFn(data);
    return res.data;
};
window.sendTemplateEmail = async (to, templateId, variables, subject) => {
    try {
        const sendTemplateEmailFn = httpsCallable(functions, 'sendTemplateEmail');
        const res = await sendTemplateEmailFn({ to, templateId, variables, subject });
        return res.data;
    } catch (error) {
        console.error("Error calling sendTemplateEmail:", error);
        throw error;
    }
};

// Specific template email helpers matching index.js templates
window.sendWelcomeEmail = async (to, userName) => {
    return window.sendTemplateEmail(to, 'welcome-email-1', {
        USER_NAME: userName || 'User'
    }, 'Welcome to QR Bloom Suite!');
};

window.sendLoginAlert = async (to, device, location) => {
    const devVal = device && device !== 'Unknown Device' ? getCleanDeviceAndBrowser(device) : getCleanDeviceAndBrowser(navigator.userAgent);
    return window.sendTemplateEmail(to, 'new-login-detected', {
        DEVICE: devVal,
        LOCATION: location || 'Unknown Location',
        TIME: formatLoginTimeClient()
    }, 'Security Alert: New Login Detected');
};

window.sendPasswordResetEmailCustom = async (to, resetLink) => {
    return window.sendTemplateEmail(to, 'password-reset', {
        RESET_LINK: resetLink
    }, 'Reset Your Password');
};

window.sendPaymentConfirmation = async (to, userName, amount, currency) => {
    return window.sendTemplateEmail(to, 'payment-confirmation', {
        USER_NAME: userName || 'User',
        AMOUNT: amount,
        CURRENCY: currency || 'INR'
    }, 'Payment Confirmation');
};

window.sendPaymentFailed = async (to, userName, amount) => {
    return window.sendTemplateEmail(to, 'payment-failed-alert', {
        USER_NAME: userName || 'User',
        AMOUNT: amount
    }, 'Action Required: Payment Failed');
};

window.sendSubscriptionCancelled = async (to, userName, isReverted) => {
    return window.sendTemplateEmail(to, 'subscription-cancelled', {
        USER_NAME: userName || 'User',
        isReverted: !!isReverted
    }, isReverted ? 'Subscription Reverted / Downgraded' : 'Subscription Cancelled');
};

window.sendAccountDeleted = async (to, userName) => {
    return window.sendTemplateEmail(to, 'account-deleted', {
        USER_NAME: userName || 'User'
    }, 'Account Deleted');
};



async function syncGoogleUserProfile(user) {
    const userRef = doc(db, "users", user.uid);
    const userSnap = await getDoc(userRef);
    let profileData;

    if (userSnap.exists()) {
        const existingData = userSnap.data();

        // [FIX] Proactively merge local state into the profile before saving
        const localChoices = JSON.parse(localStorage.getItem('user_choices') || '{}');
        const localAppLock = localStorage.getItem('\x61\x70\x70\x5f\x6c\x6f\x63\x6b\x5f\x63\x6f\x6e\x66\x69\x67');

        const updates = {
            choices: { ...(existingData.choices || {}), ...localChoices },
            lastLogin: existingData.currentLogin || "FIRST SESSION",
            currentLogin: new Date().toLocaleString()
        };

        if (localAppLock && !existingData.app_lock_config) {
            try { updates.app_lock_config = JSON.parse(localAppLock); } catch (e) { }
        }

        await updateDoc(userRef, updates);
        profileData = { ...existingData, ...updates };
    } else {
        const nameParts = user.displayName ? user.displayName.split(' ') : ["Social", "User"];

        // [NEW] Bootstrap with any existing local choices
        const localChoices = JSON.parse(localStorage.getItem('user_choices') || '{}');
        const localAppLock = localStorage.getItem('\x61\x70\x70\x5f\x6c\x6f\x63\x6b\x5f\x63\x6f\x6e\x66\x69\x67');

        profileData = {
            first: nameParts[0],
            last: nameParts.slice(1).join(' ') || "User",
            email: user.email,
            phone: user.phoneNumber || "PENDING",
            joined: new Date().toLocaleString(),
            currentLogin: new Date().toLocaleString(),
            lastLogin: "FIRST SESSION",
            authProvider: 'google.com',
            social: true,
            isVerified: true,
            uid: user.uid,
            choices: localChoices,
            role: ownerEmails.includes(user.email.toLowerCase()) ? 'owner' : 'user'
        };

        if (localAppLock) {
            try { profileData.app_lock_config = JSON.parse(localAppLock); } catch (e) { }
        }

        await setDoc(userRef, profileData);
    }

    // Encrypt and Persist
    const encrypted = CryptoJS.AES.encrypt(JSON.stringify(profileData), _getAppSecret()).toString();
    localStorage.setItem('userStoreEnc', encrypted);

    // 📊 [ANALYTICS] Track Successful Auth
    if (window.bloomAnalytics) {
        window.bloomAnalytics.logAuthAction('login_success', 'google');
    }

    if (typeof window.addSuiteNotification === 'function') {
        window.addSuiteNotification('account', 'New Login Detected', `Your account was accessed via Google from ${navigator.userAgent.includes('Windows') ? 'Windows' : 'Mobile Device'}.`, { device: navigator.userAgent.substring(0, 30), provider: 'Google', status: 'Success' });
    }

    // 📧 [RESEND] Trigger Login Notification
    try {
        const loc = await detectLocation();
        const notifyLogin = httpsCallable(functions, 'onLoginDetected');
        notifyLogin({
            email: user.email,
            device: getCleanDeviceAndBrowser(navigator.userAgent),
            location: loc,
            name: profileData.first || 'User'
        });
    } catch (e) { console.warn("Email alert deferred."); }

    return profileData;
}

// Global Bridge for Iframe Communication
window.suiteAuthBridge = {
    googleLogin: async () => {
        try {
            const result = await signInWithPopup(auth, new GoogleAuthProvider());
            const profileData = await syncGoogleUserProfile(result.user);
            return { success: true, user: profileData };
        } catch (error) {
            console.error("Firebase Bridge Error:", error);
            // 📊 [ANALYTICS] Track Auth Failure
            if (window.bloomAnalytics) {
                window.bloomAnalytics.logAuthAction('login_failure', 'google');
                window.bloomAnalytics.logError(error.message, 'google_login');
            }
            return { success: false, error };
        }
    },
    emailRegister: async (details) => {
        try {
            const cleanDetails = JSON.parse(JSON.stringify(details));
            const normalizedEmail = cleanDetails.email.toLowerCase();

            // 🚦 Signal to onAuthStateChanged bootstrap to stand down.
            // Without this, bootstrap fires concurrently, creates the Firestore doc
            // with a different 'joined' timestamp, and then emailRegister's setDoc
            // becomes an UPDATE that the joined-immutability rule rejects.
            window.isRegistering = true;

            const userCredential = await createUserWithEmailAndPassword(auth, normalizedEmail, cleanDetails.password);
            const user = userCredential.user;

            // ✅ Build profileData with only truthy/defined values.
            // Firestore rules require phone/bio/age/etc to be string type —
            // writing null for these fields causes "phone is string" to fail.
            // Solution: only include optional fields when they have a real value.
            const profileData = {
                first: cleanDetails.first || '',
                last: cleanDetails.last || '',
                email: normalizedEmail,
                uid: user.uid,
                joined: new Date().toLocaleString(),
                currentLogin: new Date().toLocaleString(),
                lastLogin: 'FIRST SESSION',
                cloudSynced: true,
                isVerified: true,
                authProvider: 'password',
                role: ownerEmails.includes(normalizedEmail) ? 'owner' : 'user'
            };
            // Optional fields: only add when the user actually filled them in
            if (cleanDetails.phone) profileData.phone = String(cleanDetails.phone);
            if (cleanDetails.age) profileData.age = String(cleanDetails.age);
            if (cleanDetails.gender) profileData.gender = String(cleanDetails.gender);
            if (cleanDetails.dob) profileData.dob = String(cleanDetails.dob);
            if (cleanDetails.pin) profileData.pin = String(cleanDetails.pin);
            if (cleanDetails.address) profileData.address = String(cleanDetails.address);
            if (cleanDetails.occupation) profileData.occupation = String(cleanDetails.occupation);
            if (cleanDetails.bio) profileData.bio = String(cleanDetails.bio);

            const userDocRef = doc(db, "users", user.uid);
            const existingSnap = await getDoc(userDocRef);
            if (existingSnap.exists()) {
                // Doc already created by bootstrap — update with form data,
                // skip 'joined' (rules protect it from being changed)
                const updateData = { ...profileData };
                delete updateData.joined;
                await updateDoc(userDocRef, updateData);
            } else {
                await setDoc(userDocRef, profileData);
            }


            // Stop local password persistence. Verification will be Cloud-only.
            const encrypted = CryptoJS.AES.encrypt(JSON.stringify(profileData), _getAppSecret()).toString();
            localStorage.setItem('userStoreEnc', encrypted);

            // 📊 [ANALYTICS] Track Registration
            if (window.bloomAnalytics) {
                window.bloomAnalytics.logAuthAction('signup_success', 'email');
            }

            return { success: true, user: profileData };
        } catch (error) {
            console.error("Firebase Registration Error:", error);
            // 📊 [ANALYTICS] Track Registration Failure
            if (window.bloomAnalytics) {
                window.bloomAnalytics.logAuthAction('signup_failure', 'email');
                window.bloomAnalytics.logError(error.message, 'email_signup');
            }
            return { success: false, error: error.message };
        } finally {
            // Always clear the flag so future logins trigger bootstrap normally
            window.isRegistering = false;
        }
    },
    updateProfile: async (data) => {
        const user = auth.currentUser;
        if (!user) return;
        try {
            const cleanData = JSON.parse(JSON.stringify(data));
            delete cleanData.password;

            const settingsToSync = cleanData.settings;
            delete cleanData.settings;

            const updates = { ...cleanData };
            if (settingsToSync) {
                Object.entries(settingsToSync).forEach(([k, v]) => {
                    if (k === 'mobile') {
                        if (v && typeof v === 'object') {
                            Object.entries(v).forEach(([mk, mv]) => {
                                updates[`settings.${mk}`] = mv;
                            });
                        }
                    } else {
                        updates[`settings.${k}`] = v;
                    }
                });
            }

            await updateDoc(doc(db, "users", user.uid), updates);
        } catch (e) {
            console.error("Profile sync failed:", e);
        }
    },
    syncProfile: async () => {
        if (typeof window.syncProfileWithCloud === 'function') {
            await window.syncProfileWithCloud();
        }
    },
    isSocialUser: () => {
        const user = auth.currentUser;
        if (!user) return false;
        return user.providerData.some(p => p.providerId === 'google.com');
    },
    reverify: async (password) => {
        const user = auth.currentUser;
        if (!user) return { success: false, error: "No active session." };
        try {
            const credential = EmailAuthProvider.credential(user.email, password);
            await reauthenticateWithCredential(user, credential);
            return { success: true };
        } catch (error) {
            console.error("Cloud Verification Failed:", error);
            let msg = "Incorrect password. Verification failed.";
            if (error.code === 'auth/invalid-credential' || error.code === 'auth/wrong-password') {
                msg = "Incorrect password. Please verify and try again.";
            } else if (error.code === 'auth/user-mismatch') {
                msg = "Security: Credential mismatch. This password belongs to a different account.";
            } else if (error.code === 'auth/too-many-requests') {
                msg = "Security: Too many failed attempts. Account locked temporarily.";
            }
            return { success: false, error: msg };
        }
    },
    changePassword: async (oldPassword, newPassword) => {
        const user = auth.currentUser;
        if (!user) return { success: false, error: "No active session." };
        try {
            const credential = EmailAuthProvider.credential(user.email, oldPassword);
            await reauthenticateWithCredential(user, credential);
            await updatePassword(user, newPassword);
            return { success: true };
        } catch (error) {
            console.error("Cloud Password Update Failed:", error);
            return { success: false, error: error.message };
        }
    },
    getAccountDiagnostics: async () => {
        const user = auth.currentUser;
        if (!user) return null;
        return {
            email: user.email,
            isSocial: user.providerData.some(p => p.providerId === 'google.com'),
            providers: user.providerData.map(p => p.providerId),
            uid: user.uid
        };
    },
    sendResetEmail: async (email) => {
        try {
            await sendPasswordResetEmail(auth, email);

            // 📧 [RESEND] Custom Template via Resend
            try {
                const customReset = httpsCallable(functions, 'sendPasswordResetEmail');
                customReset({ email, resetLink: 'https://qrbloomsuite.com/reset' });
            } catch (e) { }

            return { success: true };
        } catch (error) {
            console.error("Firebase Reset Email Error:", error);
            return { success: false, error: error.message };
        }
    },
    verifyPassword: async (identifier, password) => {
        try {
            const user = auth.currentUser;
            if (!user) return { success: false, error: "Session Expired: Please login again." };

            const email = user.email || identifier;
            const credential = EmailAuthProvider.credential(email, password);
            await reauthenticateWithCredential(user, credential);

            return { success: true };
        } catch (error) {
            console.error("🛡️ Cloud Verification: FAILED [No]", error.code);
            let msg = "Incorrect password. Please verify and try again.";
            if (error.code === 'auth/too-many-requests') {
                msg = "Security: Too many failed attempts. Account locked temporarily.";
            } else if (error.code === 'auth/user-mismatch') {
                msg = "Security: Credential mismatch. Please use the password for the current account.";
            }
            return { success: false, error: msg };
        }
    },
    pushSettingsToCloud: async () => {
        if (settingsSyncTimeout) {
            clearTimeout(settingsSyncTimeout);
            settingsSyncTimeout = null;
        }
        const user = auth.currentUser;
        if (!user) {
            isSettingsSyncPending = false;
            return;
        }

        isSettingsSyncPending = true;
        try {
            const settings = {};
            const keys = [
                'suite_sound_muted', 'suite_sound_volume',
                'suite_typing_enabled', 'suite_typing_volume', 'suite_typing_tune',
                'suite_bottom_nav_enabled', 'suite_bottom_nav_volume',
                'nav_anim_enabled',
                'session_protocol_enabled',
                'fullscreen_on_click'
            ];
            const defaults = {
                'suite_sound_muted': 'false',
                'suite_sound_volume': '0.7',
                'suite_typing_enabled': 'true',
                'suite_typing_volume': '0.5',
                'suite_typing_tune': 'TYPING_MECHANICAL',
                'suite_bottom_nav_enabled': 'true',
                'suite_bottom_nav_volume': '0.5',
                'nav_anim_enabled': 'true',
                'session_protocol_enabled': 'false',
                'fullscreen_on_click': 'false'
            };
            keys.forEach(k => {
                let v = localStorage.getItem(k);
                if (v === null && defaults[k] !== undefined) {
                    v = defaults[k];
                }
                if (v !== null) settings[k] = v;
            });

            const mode = localStorage.getItem('active_layer_mode') || '1';
            settings['active_layer_mode'] = mode;
            settings['font'] = FONT_MAP[mode] || "Space Grotesk";

            const cleanSettings = JSON.parse(JSON.stringify(settings));
            const updates = {
                "mobile": deleteField(),
                "settings.mobile": deleteField(),
                "settings": cleanSettings
            };
            await updateDoc(doc(db, "users", user.uid), updates);
            if (window.bloomAnalytics) {
                window.bloomAnalytics.logSettingsUpdate(Object.keys(settings).length);
            }
        } catch (err) {
            console.warn("☁️ Cloud: Settings sync failed", err);
        } finally {
            isSettingsSyncPending = false;
        }
    },
    removeAppLockFromCloud: async () => {
        const user = auth.currentUser;
        if (!user) return;
        try {
            const userRef = doc(db, "users", user.uid);
            await updateDoc(userRef, {
                app_lock_config: deleteField()
            });
        } catch (err) {
            console.error("🛡️ Cloud: Failed to purge App Lock data", err);
        }
    },
    emailLogin: async (identifier, password) => {
        try {
            let email = identifier.trim();
            const isPhone = /^[0-9+ \-]+$/.test(email) && !email.includes('@');
            if (isPhone) {
                try {
                    const resolvePhoneFn = httpsCallable(functions, 'resolvePhoneForLogin');
                    const res = await resolvePhoneFn({ phone: email });
                    if (!res.data || !res.data.success) {
                        return { success: false, error: (res.data && res.data.error) || "No account found with this phone number." };
                    }
                    email = res.data.email;
                } catch (fnErr) {
                    console.error("Phone resolution error:", fnErr);
                    return { success: false, error: "Unable to verify phone number. Please try again." };
                }
            }

            let userCredential;
            try {
                userCredential = await signInWithEmailAndPassword(auth, email.toLowerCase(), password);
            } catch (e1) {
                if (e1.code === 'auth/invalid-credential' || e1.code === 'auth/user-not-found' || e1.code === 'auth/invalid-email') {
                    userCredential = await signInWithEmailAndPassword(auth, email, password);
                } else {
                    throw e1;
                }
            }

            const user = userCredential.user;
            const userSnap = await getDoc(doc(db, "users", user.uid));
            let profileData;
            let isNewUser = false;
            if (userSnap.exists()) {
                const cloudData = userSnap.data();

                const localChoices = JSON.parse(localStorage.getItem('user_choices') || '{}');
                const localAppLock = localStorage.getItem('\x61\x70\x70\x5f\x6c\x6f\x63\x6b\x5f\x63\x6f\x6e\x66\x69\x67');

                const updates = {
                    choices: { ...(cloudData.choices || {}), ...localChoices },
                    lastLogin: cloudData.currentLogin || "FIRST SESSION",
                    currentLogin: new Date().toLocaleString()
                };

                if (localAppLock && !cloudData.app_lock_config) {
                    try { updates.app_lock_config = JSON.parse(localAppLock); } catch (e) { }
                }

                await updateDoc(doc(db, "users", user.uid), updates);
                profileData = { ...cloudData, ...updates };
            } else {
                isNewUser = true;
                console.warn("🚨 Profile missing in Firestore. Creating default...");
                const nameParts = user.displayName ? user.displayName.split(' ') : ["Cloud", "User"];

                const localChoices = JSON.parse(localStorage.getItem('user_choices') || '{}');
                const localAppLock = localStorage.getItem('\x61\x70\x70\x5f\x6c\x6f\x63\x6b\x5f\x63\x6f\x6e\x66\x69\x67');

                profileData = {
                    first: nameParts[0],
                    last: nameParts.slice(1).join(' ') || "User",
                    email: user.email,
                    uid: user.uid,
                    joined: new Date().toLocaleString(),
                    currentLogin: new Date().toLocaleString(),
                    lastLogin: "RESTORED SESSION",
                    authProvider: 'password',
                    isVerified: true,
                    choices: localChoices,
                    role: ownerEmails.includes(user.email.toLowerCase()) ? 'owner' : 'user'
                };

                if (localAppLock) {
                    try { profileData.app_lock_config = JSON.parse(localAppLock); } catch (e) { }
                }
            }

            if (isNewUser) {
                await setDoc(doc(db, "users", user.uid), profileData);
            }

            delete profileData.password;
            delete profileData.confirm;

            const encrypted = CryptoJS.AES.encrypt(JSON.stringify(profileData), _getAppSecret()).toString();
            localStorage.setItem('userStoreEnc', encrypted);

            if (window.bloomAnalytics) {
                window.bloomAnalytics.logAuthAction('login_success', 'email');
            }

            if (typeof window.addSuiteNotification === 'function') {
                window.addSuiteNotification('account', 'New Login Detected', `Your account was accessed via Email from ${navigator.userAgent.includes('Windows') ? 'Windows' : 'Mobile Device'}.`, { device: navigator.userAgent.substring(0, 30), provider: 'Email', status: 'Success' });
            }

            try {
                const loc = await detectLocation();
                const notifyLogin = httpsCallable(functions, 'onLoginDetected');
                notifyLogin({
                    email: profileData.email,
                    device: getCleanDeviceAndBrowser(navigator.userAgent),
                    location: loc,
                    name: profileData.first || 'User'
                });
            } catch (e) { }

            return { success: true, user: profileData };
        } catch (error) {
            console.error("Firebase Login Error:", error);
            let msg = error.message;
            if (error.code === 'auth/invalid-credential' || error.code === 'auth/wrong-password') {
                msg = "Incorrect password. Please verify and try again.";
            } else if (error.code === 'auth/user-not-found') {
                msg = "Account not found. Please check the email spelling or register.";
            } else if (error.code === 'auth/too-many-requests') {
                msg = "Security block: Too many failed attempts. Try again later.";
            }
            if (window.bloomAnalytics) {
                window.bloomAnalytics.logAuthAction('login_failure', 'email');
                window.bloomAnalytics.logError(error.message, 'email_login');
            }
            return { success: false, error: msg, code: error.code };
        }
    },
    deleteAccount: async (password = null) => {
        if (window.bloomAnalytics) {
            window.bloomAnalytics.logAuthAction('delete_account_start', 'n/a');
        }
        try {
            const user = auth.currentUser;
            if (!user) {
                localStorage.clear();
                return { success: true };
            }

            const userEmail = user.email || (user.providerData && user.providerData[0] ? user.providerData[0].email : null);

            try {
                if (password) {
                    const credential = EmailAuthProvider.credential(userEmail, password);
                    await reauthenticateWithCredential(user, credential);
                } else {
                    const provider = new GoogleAuthProvider();
                    await reauthenticateWithPopup(user, provider);
                }
            } catch (reAuthErr) {
                console.error("Final Re-auth Failure:", reAuthErr);
                if (reAuthErr.code === 'auth/invalid-credential' && password) {
                    await signInWithEmailAndPassword(auth, userEmail, password);
                } else {
                    return { success: false, error: "Deletion verification failed. Please try logging in again first." };
                }
            }

            await deleteDoc(doc(db, "users", user.uid));
            await deleteUser(user);

            localStorage.clear();

            if (typeof switchView === 'function') switchView('about-w11', 0);
            setTimeout(() => window.location.reload(), 500);

            return { success: true };
        } catch (error) {
            console.error("CRITICAL DELETION ERROR:", error);
            return { success: false, error: error.message };
        }
    },
    logout: async () => {
        try {
            if (window.userSnapshotListener) {
                try { window.userSnapshotListener(); } catch (e) { }
                window.userSnapshotListener = null;
            }
            await signOut(auth);
            localStorage.removeItem('userStoreEnc');
            if (window.bloomAnalytics) {
                window.bloomAnalytics.logAuthAction('logout', 'n/a');
            }
            return { success: true };
        } catch (error) {
            console.error("Firebase Logout Error:", error);
            return { success: false, error: error.message };
        }
    },
    syncFavoriteToCloud: async (item) => {
        const user = auth.currentUser;
        if (!user) return;
        try {
            const favRef = doc(db, "users", user.uid, "favorites", item.id);
            if (item.isFavorite) {
                const cloudData = {
                    ...item,
                    added_to_cloud: new Date().toLocaleString(),
                };
                if (cloudData.timestamp) delete cloudData.timestamp;

                await setDoc(favRef, cloudData);
                if (window.bloomAnalytics) {
                    window.bloomAnalytics.logFavoriteSync('add', item.id);
                }
            } else {
                await deleteDoc(favRef);
                if (window.bloomAnalytics) {
                    window.bloomAnalytics.logFavoriteSync('remove', item.id);
                }
            }
        } catch (err) {
            console.warn("☁️ Cloud: Favorite sync deferred or failed", err);
        }
    }
};

// --- User Choice & Preference Engine ---
window.recordUserChoice = async (type, choice) => {
    let choices = JSON.parse(localStorage.getItem('user_choices') || '{}');
    choices[type] = choice;
    localStorage.setItem('user_choices', JSON.stringify(choices));

    const user = auth.currentUser;
    if (user) {
        try {
            await setDoc(doc(db, "users", user.uid), { choices }, { merge: true });
        } catch (e) {
            console.warn("☁️ Cloud: Choice sync deferred.", e);
        }
    }
};

// Global Sync Flags
window.isCloudSyncing = true;
window.hasVerifiedThisSession = false;

window.syncBatchUsageToFirebase = async (usageVal) => {
    try {
        const user = auth.currentUser;
        if (user && db && setDoc && doc && getDoc) {
            const docRef = doc(db, 'users', user.uid);
            let currentServerVal = 0;
            try {
                const snap = await getDoc(docRef);
                if (snap.exists()) {
                    const data = snap.data();
                    if (data && data.qr_batch_usage !== undefined && data.qr_batch_usage !== null) {
                        currentServerVal = parseInt(data.qr_batch_usage) || 0;
                    }
                } else {
                    return;
                }
            } catch (readErr) {
                console.warn("Failed to read user profile for usage sync:", readErr);
            }

            if (usageVal > currentServerVal) {
                await setDoc(
                    docRef,
                    {
                        qr_batch_usage: usageVal
                    },
                    { merge: true }
                );
            }
        }
    } catch (e) {
        console.error("Error syncing batch usage to Firebase:", e);
    }
};

window.getFirebaseBatchUsage = async () => {
    try {
        const user = auth.currentUser;
        if (user && db && doc && getDocFromServer) {
            const userSnap = await getDocFromServer(doc(db, "users", user.uid));
            if (userSnap.exists()) {
                const data = userSnap.data();
                if (data && data.qr_batch_usage !== undefined && data.qr_batch_usage !== null) {
                    const usageVal = parseInt(data.qr_batch_usage) || 0;
                    window._qrbloom_batch_usage = usageVal;
                    try { localStorage.removeItem('qr_batch_usage'); } catch(e) {}
                    return usageVal;
                }
            }
        }
    } catch (e) {
        console.error("Error fetching batch usage from Firebase:", e);
    }
    return window._qrbloom_batch_usage || 0;
};

window.syncDynamicUsageToFirebase = async (usageVal) => {
    window._qrbloom_dynamic_usage = usageVal;
    try {
        const user = auth.currentUser;
        if (user && db && updateDoc && doc) {
            await updateDoc(
                doc(db, 'users', user.uid),
                {
                    qr_dynamic: usageVal
                }
            );
        }
    } catch (e) {
        console.error("Error syncing dynamic usage to Firebase:", e);
    }
};

window.getFirebaseDynamicUsage = async () => {
    try {
        const user = auth.currentUser;
        if (user && db && doc && getDocFromServer) {
            const userSnap = await getDocFromServer(doc(db, "users", user.uid));
            if (userSnap.exists()) {
                const data = userSnap.data();
                if (data && data.qr_dynamic !== undefined && data.qr_dynamic !== null) {
                    const usageVal = parseInt(data.qr_dynamic) || 0;
                    window._qrbloom_dynamic_usage = usageVal;
                    try { localStorage.removeItem('qr_dynamic'); } catch(e) {}
                    return usageVal;
                }
            }
        }
    } catch (e) {
        console.error("Error fetching dynamic usage from Firebase:", e);
    }
    return window._qrbloom_dynamic_usage || 0;
};

// GLOBAL SLOT SYNC TO FIREBASE
let _syncSlotsTimeout = null;
window.syncUsedSlotsToFirebase = () => {
    if (_syncSlotsTimeout) clearTimeout(_syncSlotsTimeout);
    _syncSlotsTimeout = setTimeout(async () => {
        const user = auth && auth.currentUser;
        if (!user) return;
        try {
            let qrCreated = 0;
            let qrDecoded = 0;
            let barcodesDecoded = 0;
            let barcodesCreated = 0;

            if (window.QRHistoryDB && typeof window.QRHistoryDB.init === 'function') await window.QRHistoryDB.init();
            if (window.QRHistoryDB && typeof window.QRHistoryDB.getAll === 'function') {
                const creatorItems = await window.QRHistoryDB.getAll('creator_history');
                qrCreated = creatorItems.filter(i => i.type !== 'barcode' && !i.isDynamic).length;
                barcodesCreated = creatorItems.filter(i => i.type === 'barcode').length;

                const decoderItems = await window.QRHistoryDB.getAll('decoder_history');
                barcodesDecoded = decoderItems.length;
            }

            if (window.QRDecoderHistoryDB && typeof window.QRDecoderHistoryDB.init === 'function') await window.QRDecoderHistoryDB.init();
            if (window.QRDecoderHistoryDB && typeof window.QRDecoderHistoryDB.getAll === 'function') {
                const qrDecodedItems = await window.QRDecoderHistoryDB.getAll('qr_decoder_history');
                qrDecoded = qrDecodedItems.length;
            }

            await updateDoc(doc(db, "users", user.uid), {
                qr_creator_usage: qrCreated,
                qr_decoder_usage: qrDecoded,
                barcode_creator_usage: barcodesCreated,
                barcode_decoder_usage: barcodesDecoded
            }).catch(err => {
                console.warn("☁️ Failed to sync slot usage to Firestore:", err);
            });
        } catch (e) {
            console.error("Error calculating or syncing slot usage:", e);
        }
    }, 500); // 500ms debounce to prevent IndexedDB transaction race conditions
};

// REUSABLE CLOUD SYNC LOGIC
window.syncProfileWithCloud = async () => {
    const user = auth.currentUser;
    if (!user) {
        window.isCloudSyncing = false;
        if (typeof updateMomentumDash === 'function') updateMomentumDash();
        return;
    }

    window.isCloudSyncing = true;
    if (typeof updateMomentumDash === 'function') updateMomentumDash();

    try {
        // Background Sync: No UI disruption/notification popup
        // if (typeof pop === 'function') pop("Synchronizing with Cloud...", "info");
        const userSnap = await getDocFromServer(doc(db, "users", user.uid));
        if (userSnap.exists()) {
            const profileData = userSnap.data();
            delete profileData.password;
            delete profileData.confirm;

            // Ensure role matches the backend owner check on load/sync
            const correctRole = ownerEmails.includes(user.email.toLowerCase()) ? 'owner' : 'user';
            if (profileData.role !== correctRole) {
                profileData.role = correctRole;
                await updateDoc(doc(db, "users", user.uid), { role: correctRole }).catch(err => {
                    console.warn("☁️ Failed to update role in Firestore:", err);
                });
            }

            profileData.isVerified = true;
            window.userData = profileData;

            if (profileData.qr_batch_usage !== undefined && profileData.qr_batch_usage !== null) {
                window._qrbloom_batch_usage = parseInt(profileData.qr_batch_usage) || 0;
            } else {
                const localUsage = window._qrbloom_batch_usage || 0;
                await updateDoc(doc(db, "users", user.uid), { qr_batch_usage: parseInt(localUsage) }).catch(() => { });
            }
            try { localStorage.removeItem('qr_batch_usage'); } catch(e) {}

            // --- TRACK USED SLOTS ---
            if (window.syncUsedSlotsToFirebase) {
                await window.syncUsedSlotsToFirebase();
            }
            // --- END TRACK USED SLOTS ---

            if (profileData.qr_dynamic !== undefined && profileData.qr_dynamic !== null) {
                window._qrbloom_dynamic_usage = parseInt(profileData.qr_dynamic) || 0;
            } else {
                const localUsage = window._qrbloom_dynamic_usage || 0;
                await updateDoc(doc(db, "users", user.uid), { qr_dynamic: parseInt(localUsage) }).catch(() => { });
            }
            try { localStorage.removeItem('qr_dynamic'); } catch(e) {}

            const localChoices = JSON.parse(localStorage.getItem('user_choices') || '{}');
            const cloudChoices = profileData.choices || {};

            // Migrate legacy mobile choices if they exist
            if (cloudChoices.mobile && cloudChoices.mobile.privacy) {
                cloudChoices.privacy = cloudChoices.mobile.privacy.choice || cloudChoices.mobile.privacy;
            }
            if (localChoices.mobile && localChoices.mobile.privacy) {
                localChoices.privacy = localChoices.mobile.privacy.choice || localChoices.mobile.privacy;
                delete localChoices.mobile;
                localStorage.setItem('user_choices', JSON.stringify(localChoices));
            }

            const mergedChoices = { ...cloudChoices, ...localChoices };
            if (mergedChoices.mobile) {
                delete mergedChoices.mobile;
            }

            if (JSON.stringify(cloudChoices) !== JSON.stringify(mergedChoices)) {
                await setDoc(doc(db, "users", user.uid), { choices: mergedChoices }, { merge: true });
                await updateDoc(doc(db, "users", user.uid), { "choices.mobile": deleteField() }).catch(() => { });
                profileData.choices = mergedChoices;
                localStorage.setItem('user_choices', JSON.stringify(mergedChoices));
            }

            const privacyVal = mergedChoices.privacy ? (mergedChoices.privacy.choice || mergedChoices.privacy) : null;
            if (privacyVal) {
                localStorage.setItem('privacy_persistent_choice', privacyVal);
            }

            const encrypted = CryptoJS.AES.encrypt(JSON.stringify(profileData), _getAppSecret()).toString();
            localStorage.setItem('userStoreEnc', encrypted);

            const localAppLockRaw = safeStorage.getItem('app_lock_config');
            const cloudAppLock = profileData.app_lock_config;

            if (cloudAppLock) {
                const cloudConfigStr = JSON.stringify(cloudAppLock);
                if (localAppLockRaw !== cloudConfigStr) {
                    safeStorage.setItem('app_lock_config', cloudConfigStr);
                    if (window._0x83e2 && typeof window._0x83e2.checkAppLock === 'function') {
                        window._0x83e2.checkAppLock();
                    }
                }
            } else if (localAppLockRaw) {
                try {
                    const config = JSON.parse(localAppLockRaw);
                    await updateDoc(doc(db, "users", user.uid), { app_lock_config: config });
                } catch (e) { }
            } else {
                if (localAppLockRaw) {
                    safeStorage.removeItem('app_lock_config');
                    if (window._0x83e2 && typeof window._0x83e2.checkAppLock === 'function') {
                        window._0x83e2.checkAppLock();
                    }
                }
            }

            // Fetch Mobile Settings from user profile document (migrated from settings.mobile or mobile)
            let ms = null;
            if (profileData.settings) {
                if (profileData.settings.mobile) {
                    ms = profileData.settings.mobile;
                } else {
                    const hasKeys = Object.keys(profileData.settings).some(k => k.startsWith('suite_') || k === 'active_layer_mode' || k === 'font');
                    if (hasKeys) {
                        ms = profileData.settings;
                    }
                }
            }
            if (!ms && profileData.mobile) {
                ms = profileData.mobile;
            }
            if (ms) {

                // 1. Resolve Font Mode / Font Name
                let fontMode = null;
                if (ms.active_layer_mode !== undefined && ms.active_layer_mode !== null) {
                    fontMode = String(ms.active_layer_mode);
                } else if (ms.font !== undefined && ms.font !== null) {
                    const fontVal = String(ms.font).trim();
                    if (FONT_MAP[fontVal]) {
                        fontMode = fontVal;
                    } else {
                        fontMode = REVERSE_FONT_MAP[fontVal] || "1";
                    }
                }

                if (fontMode) {
                    if (localStorage.getItem('active_layer_mode') !== fontMode) {
                        if (window.safeStorage) {
                            window.safeStorage.setItem('active_layer_mode', fontMode, true);
                        } else {
                            localStorage.setItem('active_layer_mode', fontMode);
                            window.dispatchEvent(new CustomEvent('safeStorageChange', { detail: { key: 'active_layer_mode', val: fontMode, isRemote: true } }));
                        }
                    }
                    // Force apply the font mode to the UI
                    const parsedMode = parseInt(fontMode);
                    if (!isNaN(parsedMode)) {
                        window.syncFontMode(parsedMode);
                    }
                }

                // 2. Resolve all other keys
                Object.entries(ms).forEach(([key, val]) => {
                    if (key === 'font' || key === 'active_layer_mode') return; // Handled above
                    if (localStorage.getItem(key) !== String(val)) {
                        if (window.safeStorage) {
                            window.safeStorage.setItem(key, val, true);
                        } else {
                            localStorage.setItem(key, val);
                            window.dispatchEvent(new CustomEvent('safeStorageChange', { detail: { key, val, isRemote: true } }));
                        }
                    }
                });

                // 3. Proactively migrate and clean up root-level 'mobile' and nested 'settings.mobile' fields if they exist
                if (profileData.mobile || (profileData.settings && profileData.settings.mobile)) {
                    try {
                        await updateDoc(doc(db, "users", user.uid), {
                            "settings": ms,
                            "mobile": deleteField(),
                            "settings.mobile": deleteField()
                        });
                    } catch (e) {
                        console.warn("🧹 Cloud: Failed to delete legacy 'mobile' maps", e);
                    }
                }

                // Check if any syncable key is missing in Firestore mobile settings
                const keys = [
                    'suite_sound_muted', 'suite_sound_volume',
                    'suite_typing_enabled', 'suite_typing_volume', 'suite_typing_tune',
                    'suite_bottom_nav_enabled', 'suite_bottom_nav_volume',
                    'nav_anim_enabled', 'active_layer_mode',
                    'session_protocol_enabled', 'fullscreen_on_click'
                ];
                const hasAllKeys = keys.every(k => ms[k] !== undefined && ms[k] !== null);
                if (!hasAllKeys) {
                    console.log("☁️ Cloud: Some mobile settings are missing. Pushing full configuration...");
                    window.suiteAuthBridge.pushSettingsToCloud();
                }
            } else {
                const settings = {};
                const keys = [
                    'suite_sound_muted', 'suite_sound_volume',
                    'suite_typing_enabled', 'suite_typing_volume', 'suite_typing_tune',
                    'suite_bottom_nav_enabled', 'suite_bottom_nav_volume',
                    'nav_anim_enabled',
                    'session_protocol_enabled',
                    'fullscreen_on_click'
                ];
                const defaults = {
                    'suite_sound_muted': 'false',
                    'suite_sound_volume': '0.7',
                    'suite_typing_enabled': 'true',
                    'suite_typing_volume': '0.5',
                    'suite_typing_tune': 'TYPING_MECHANICAL',
                    'suite_bottom_nav_enabled': 'true',
                    'suite_bottom_nav_volume': '0.5',
                    'nav_anim_enabled': 'true',
                    'session_protocol_enabled': 'false',
                    'fullscreen_on_click': 'false'
                };
                keys.forEach(k => {
                    let v = localStorage.getItem(k);
                    if (v === null && defaults[k] !== undefined) {
                        v = defaults[k];
                    }
                    if (v !== null) settings[k] = v;
                });
                const mode = localStorage.getItem('active_layer_mode') || '1';
                settings['active_layer_mode'] = mode;
                settings['font'] = FONT_MAP[mode] || "Space Grotesk";
                try {
                    const cleanSettings = JSON.parse(JSON.stringify(settings));
                    await updateDoc(doc(db, "users", user.uid), {
                        "settings": cleanSettings,
                        "mobile": deleteField(),
                        "settings.mobile": deleteField()
                    });
                } catch (err) {
                    console.warn("☁️ Cloud: Failed to bootstrap mobile settings", err);
                }
            }

            try {
                const favsSnap = await getDocs(collection(db, "users", user.uid, "favorites"));
                const cloudFavs = favsSnap.docs.map(d => d.data());
                if (cloudFavs.length > 0) {
                    const limits = typeof getCurrentStorageLimits === 'function' ? getCurrentStorageLimits() : { creator: 50 };
                    if (window.QRHistoryDB) {
                        for (const fav of cloudFavs) {
                            const itemToStore = {
                                ...fav,
                                isFavorite: true,
                                type: 'qr'
                            };
                            if (itemToStore.timestamp) delete itemToStore.timestamp;

                            await window.QRHistoryDB.addItem('creator_history', itemToStore, limits.creator);
                        }
                        if (typeof renderVaultHistory === 'function') {
                            setTimeout(() => renderVaultHistory(), 500);
                        }
                    }
                }
            } catch (favErr) {
                console.warn("☁️ Cloud: Failed to hydrate favorites", favErr);
            }

            // Background Sync: No UI disruption/notification popup
            // if (typeof pop === 'function') pop("Your profile changes have been securely saved.", "success");
        } else {
            // 🚦 Skip bootstrap write if emailRegister is handling this new user.
            // Race condition: both fire simultaneously, bootstrap would create the doc
            // with a different 'joined' timestamp, then emailRegister's setDoc becomes
            // an UPDATE and the joined-immutability rule in Firestore rejects it.
            if (window.isRegistering) return;

            console.info("ℹ️ No Firestore profile found — creating bootstrap record...");
            const nameParts = user.displayName ? user.displayName.split(' ') : ["Cloud", "User"];
            const recoveryData = {
                first: nameParts[0],
                last: nameParts.slice(1).join(' ') || "User",
                email: user.email,
                uid: user.uid,
                joined: new Date().toLocaleString(),
                currentLogin: new Date().toLocaleString(),
                lastLogin: "NEW_BOOTSTRAP",
                authProvider: user.providerData[0]?.providerId || 'unknown',
                isVerified: true,
                role: ownerEmails.includes(user.email.toLowerCase()) ? 'owner' : 'user'
            };

            const bootstrapRef = doc(db, "users", user.uid);
            const bootstrapSnap = await getDoc(bootstrapRef);
            if (bootstrapSnap.exists()) {
                // Doc already created — update without overwriting joined
                const { joined, ...updateRecovery } = recoveryData;
                await updateDoc(bootstrapRef, updateRecovery);
            } else {
                await setDoc(bootstrapRef, recoveryData);
            }
            window.userData = recoveryData;
            const encrypted = CryptoJS.AES.encrypt(JSON.stringify(recoveryData), _getAppSecret()).toString();
            localStorage.setItem('userStoreEnc', encrypted);
            // Silently bootstrap during fresh registration — emailRegister will show its own success toast
            // if (typeof pop === 'function') pop("Profile Bootstrapped to Cloud", "success");
        }
    } catch (e) {
        console.error("❌ Cloud Sync Failed:", e);
        if (typeof pop === 'function') pop("Cloud Sync Failed: " + e.message, "error");
    } finally {
        window.isCloudSyncing = false;
        window.hasVerifiedThisSession = true;
        if (typeof updateMomentumDash === 'function') updateMomentumDash();
        if (typeof updateAvatarUI === 'function') updateAvatarUI();
    }
};

// ═══════════════════════════════════════════════════════════════════════
// 🔐 BLOOM SUBSCRIPTION MANAGER — Firebase-Backed Plan Verification
// Source of Truth: Firestore users/{uid}/subscription
// Cache: localStorage qrbloom_sub_enc (AES encrypted)
// History: Firestore users/{uid}/subscriptionHistory (subcollection)
// Rule: If not logged in → always FOUNDATION. Login → sync from Firebase.
// ═══════════════════════════════════════════════════════════════════════
Object.defineProperty(window, 'BloomSubscription', {
    value: (function () {

        // ── Internal tier map ──
        const TIER_MAP = { 'normal': 'foundation', 'foundation': 'foundation', 'max': 'velocity', 'velocity': 'velocity', 'pro': 'quantum', 'quantum': 'quantum', 'ultra': 'ultra' };
        const TIER_TO_INTERNAL = { 'foundation': 'normal', 'velocity': 'max', 'quantum': 'pro', 'ultra': 'ultra' };
        const TIER_RANK = { 'foundation': 0, 'normal': 0, 'velocity': 1, 'max': 1, 'quantum': 2, 'pro': 2, 'ultra': 3 };
        const CACHE_KEY = 'qrbloom_sub_enc';
        const PLAN_KEY = 'user_subscription';
        const HISTORY_CACHE_KEY = 'qrbloom_sub_history';

        // ── Helpers ──
        function _encrypt(obj) {
            try {
                const user = _user();
                if (!user) return null;
                obj.uid = user.uid; // bind cache to the user's UID
                const signPayload = user.uid + obj.plan + (obj.expiresAtMs || 0) + _getAppSecret();
                obj.signature = CryptoJS.SHA256(signPayload).toString();
                return CryptoJS.AES.encrypt(JSON.stringify(obj), _getAppSecret()).toString();
            } catch (e) { return null; }
        }
        function _decrypt(str) {
            try {
                const b = CryptoJS.AES.decrypt(str, _getAppSecret());
                const obj = JSON.parse(b.toString(CryptoJS.enc.Utf8));
                const user = _user();
                if (!user || obj.uid !== user.uid) return null; // Reject if UID mismatch

                // Verify the signature
                const signPayload = user.uid + obj.plan + (obj.expiresAtMs || 0) + _getAppSecret();
                const expectedSignature = CryptoJS.SHA256(signPayload).toString();
                if (obj.signature !== expectedSignature) {
                    console.warn('[BloomSub] Cache signature mismatch, rejecting cache');
                    return null; // Reject if tampered
                }
                return obj;
            } catch (e) { return null; }
        }
        function _now() { return Date.now(); }
        function _isoNow() { return new Date().toISOString(); }

        // ── Get current auth user ──
        function _user() { return auth && auth.currentUser ? auth.currentUser : null; }

        // ── Build a clean subscription object from Firestore data ──
        function _buildSubObj(data) {
            const exMs = data.expiresAtMs || (data.expiresAt ? new Date(data.expiresAt).getTime() : 0);
            const purchMs = data.purchasedAtMs || (data.purchasedAt ? new Date(data.purchasedAt).getTime() : 0);
            const now = _now();
            const daysLeft = exMs ? Math.max(0, Math.ceil((exMs - now) / 86400000)) : 0;
            const isActive = (data.plan === 'foundation' || data.plan === 'normal') ? true : (exMs > now && data.status === 'active');
            const hoursLeft = exMs ? Math.max(0, Math.floor((exMs - now) / 3600000)) : 0;
            const minutesLeft = exMs ? Math.max(0, Math.floor(((exMs - now) % 3600000) / 60000)) : 0;
            return {
                plan: data.plan || 'foundation',
                planDisplay: (window.planFullData && window.planFullData[data.plan]) ? window.planFullData[data.plan].name : (data.plan || 'FOUNDATION').toUpperCase(),
                status: isActive ? 'active' : 'expired',
                isActive,
                purchasedAt: data.purchasedAt || null,
                purchasedAtMs: purchMs || null,
                expiresAt: data.expiresAt || null,
                expiresAtMs: exMs || null,
                durationDays: data.durationDays || null,
                daysLeft,
                hoursLeft,
                minutesLeft,
                paymentId: data.paymentId || null,
                orderId: data.orderId || null,
                amount: data.amount || null,
                currency: data.currency || 'INR',
                gateway: data.gateway || null,
                lastVerifiedAt: _isoNow(),
                lastResetAt: data.lastResetAt || null,
                resetCount: data.resetCount || 0,
                dynamicQrLimit: data.dynamicQrLimit !== undefined ? data.dynamicQrLimit : (data.plan === 'ultra' ? 30 : (data.plan === 'pro' ? 10 : 0)),
                // Extra properties required for the UI details modal:
                legacyId: data.legacyId || null,
                userName: data.userName || null,
                planNameDisplay: data.planNameDisplay || null,
                priceStr: data.priceStr || null,
                discount: data.discount !== undefined ? data.discount : 0,
                upgradeSequence: data.upgradeSequence || 1,
                elevationStatusDisplay: data.elevationStatusDisplay || null
            };
        }

        // ── Write cache to localStorage ──
        function _writeCache(subObj) {
            try {
                const enc = _encrypt(subObj);
                if (enc) localStorage.setItem(CACHE_KEY, enc);
                // user_subscription must never exist in plain localStorage
                localStorage.removeItem(PLAN_KEY);
            } catch (e) { }
        }

        // ── Read cache from localStorage ──
        function _readCache() {
            try {
                const enc = localStorage.getItem(CACHE_KEY);
                if (!enc) return null;
                return _decrypt(enc);
            } catch (e) { return null; }
        }

        // ── Clear cache ──
        function _clearCache() {
            try {
                localStorage.removeItem(CACHE_KEY);
                localStorage.removeItem(HISTORY_CACHE_KEY);
            } catch (e) { }
        }

        // ── Apply plan to runtime and fire event ──
        function _applyPlan(subObj, reason) {
            const internalPlan = TIER_TO_INTERNAL[subObj.plan] || 'normal';
            const oldPlan = (window.BLOOM_PLAN && window.BLOOM_PLAN.plan) ? (TIER_TO_INTERNAL[window.BLOOM_PLAN.plan] || 'normal') : 'normal';
            window.BLOOM_PLAN = subObj;
            _writeCache(subObj);
            // Notify all listeners
            window.dispatchEvent(new CustomEvent('safeStorageChange', { detail: { key: PLAN_KEY, val: internalPlan } }));
            window.dispatchEvent(new CustomEvent('bloomPlanChanged', { detail: { plan: internalPlan, planObj: subObj, reason: reason || 'sync' } }));
            // Propagate to iframes
            document.querySelectorAll('iframe').forEach(iframe => {
                try {
                    if (iframe.contentWindow) {
                        iframe.contentWindow.dispatchEvent(new CustomEvent('safeStorageChange', { detail: { key: PLAN_KEY, val: internalPlan } }));
                    }
                } catch (e) { }
            });
            // Trigger UI refresh if plan changed
            if (oldPlan !== internalPlan) {
                if (typeof handlePlanChangeRefresh === 'function') {
                    setTimeout(handlePlanChangeRefresh, 100);
                }
            }
            // console.log(`✅ [BloomSub] Plan applied: ${subObj.plan} | Status: ${subObj.status} | Reason: ${reason || 'sync'}`);
        }

        // ── Set foundation (free) plan ──
        function _applyFoundation(reason) {
            const foundationObj = _buildSubObj({ plan: 'foundation', status: 'active', expiresAtMs: 0, purchasedAtMs: 0 });
            _applyPlan(foundationObj, reason || 'no_login');
        }

        // ── Log to subscriptionHistory subcollection ──
        async function _logHistory(uid, action, subObj, previousPlan, note) {
            try {
                const historyRef = collection(db, 'users', uid, 'subscriptionHistory');

                // Only update and delete history when upgrading/purchasing a new paid running plan
                if (subObj && subObj.plan && subObj.plan !== 'foundation') {
                    // Delete all previous history documents
                    const snap = await getDocs(historyRef);
                    for (const docSnap of snap.docs) {
                        try {
                            await deleteDoc(docSnap.ref);
                        } catch (delErr) {
                            console.warn('[BloomSub] Failed to delete previous history doc:', delErr);
                        }
                    }

                    const record = {
                        action,
                        plan: subObj.plan,
                        previousPlan: previousPlan || 'foundation',
                        timestamp: _isoNow(),
                        timestampMs: _now(),
                        paymentId: subObj.paymentId || null,
                        orderId: subObj.orderId || null,
                        amount: subObj.amount || null,
                        currency: subObj.currency || 'INR',
                        gateway: subObj.gateway || null,
                        purchasedAt: subObj.purchasedAt || null,
                        expiresAt: subObj.expiresAt || null,
                        durationDays: subObj.durationDays || null,
                        note: note || ''
                    };
                    await addDoc(historyRef, record);
                }
            } catch (e) {
                console.warn('[BloomSub] Failed to log history:', e);
            }
        }

        // ═══════════════════════════════
        // PUBLIC API
        // ═══════════════════════════════

        // Get current active plan tier (internal key: 'normal', 'max', 'pro', 'ultra')
        function getActivePlan() {
            if (!_user()) return 'normal';
            const cached = _readCache();
            if (cached && cached.isActive) {
                return TIER_TO_INTERNAL[cached.plan] || 'normal';
            }
            return 'normal';
        }

        // Get full subscription object
        function getPlanData() {
            if (!_user()) return _buildSubObj({ plan: 'foundation', status: 'active', expiresAtMs: 0 });
            const cached = _readCache();
            return cached || _buildSubObj({ plan: 'foundation', status: 'active', expiresAtMs: 0 });
        }

        // Is current plan active (not expired)?
        function isPlanActive() {
            if (!_user()) return false; // foundation doesn't "expire" but is base
            const data = getPlanData();
            return data.isActive;
        }

        // Days remaining on current plan
        function getDaysRemaining() {
            const data = getPlanData();
            return data.daysLeft || 0;
        }

        // Formatted time left string
        function getTimeLeftString() {
            const data = getPlanData();
            if (!data.expiresAtMs || data.plan === 'foundation') return 'Lifetime';
            if (!data.isActive) return 'Expired';
            if (data.daysLeft > 1) return `${data.daysLeft}d left`;
            if (data.hoursLeft > 0) return `${data.hoursLeft}h ${data.minutesLeft}m left`;
            return `${data.minutesLeft}m left`;
        }

        // ── Sync plan from Firestore (cloud-first verification) ──
        async function syncFromFirebase() {
            const user = _user();
            if (!user) {
                _applyFoundation('no_login');
                return { plan: 'foundation', source: 'no_login' };
            }
            try {
                const userSnap = await getDocFromServer(doc(db, 'users', user.uid));
                if (!userSnap.exists()) {
                    _applyFoundation('missing_profile');
                    return { plan: 'foundation', source: 'missing_profile' };
                }
                const userData = userSnap.data();
                let sub = userData.subscription;

                if (!sub) {
                    sub = {
                        plan: 'foundation',
                        status: 'active',
                        expiresAt: null,
                        expiresAtMs: null,
                        purchasedAt: null,
                        purchasedAtMs: null,
                        lastResetAt: null,
                        resetCount: 0,
                        lastVerifiedAt: _isoNow(),
                        dynamicQrLimit: 0
                    };
                    try {
                        await updateDoc(doc(db, 'users', user.uid), { subscription: sub });
                        console.log('[BloomSub] Initialized missing subscription map in Firestore to Foundation');
                    } catch (subInitErr) {
                        console.warn('[BloomSub] Failed to initialize subscription map in Firestore:', subInitErr);
                    }
                } else if (sub.plan && sub.dynamicQrLimit === undefined) {
                    const calculatedLimit = (sub.plan === 'ultra') ? 30 : ((sub.plan === 'pro') ? 10 : 0);
                    sub.dynamicQrLimit = calculatedLimit;
                    try {
                        await updateDoc(doc(db, 'users', user.uid), {
                            'subscription.dynamicQrLimit': calculatedLimit
                        });
                        console.log('[BloomSub] Proactively added missing dynamicQrLimit to Firestore subscription map:', calculatedLimit);
                    } catch (limitErr) {
                        console.warn('[BloomSub] Failed to proactively write dynamicQrLimit to Firestore:', limitErr);
                    }
                }

                // ONE-TIME CLEANUP & MIGRATION: If legacy flat fields exist at the root, migrate them to nested subscription map and purge root fields
                if (userData && userData.plan !== undefined) {
                    console.log('[BloomSub] Migrating legacy flat subscription fields to nested map...');
                    const prevResetCount = userData.resetCount !== undefined ? userData.resetCount : (sub && sub.resetCount !== undefined ? sub.resetCount : 0);
                    const prevLastResetAt = userData.lastResetAt !== undefined ? userData.lastResetAt : (sub && sub.lastResetAt !== undefined ? sub.lastResetAt : null);

                    if (userData.plan !== 'foundation') {
                        sub = {
                            plan: userData.plan,
                            status: userData.status || 'active',
                            purchasedAt: userData.purchasedAt || null,
                            purchasedAtMs: userData.purchasedAtMs || null,
                            expiresAt: userData.expiresAt || null,
                            expiresAtMs: userData.expiresAtMs || null,
                            durationDays: userData.durationDays || null,
                            lastVerifiedAt: userData.lastVerifiedAt || null,
                            lastResetAt: prevLastResetAt,
                            resetCount: prevResetCount,
                            elevationStatusDisplay: userData.elevationStatusDisplay || null,
                            upgradeSequence: userData.upgradeSequence || 1,
                            userName: userData.userName || null,
                            planNameDisplay: userData.planNameDisplay || null,
                            amountPaidDisplay: userData.amountPaidDisplay || null,
                            priceStr: userData.priceStr || null,
                            priceAmount: userData.priceAmount || null,
                            upgradeDiscountDisplay: userData.upgradeDiscountDisplay || null,
                            discount: userData.discount || 0,
                            purchaseDateDisplay: userData.purchaseDateDisplay || null,
                            purchaseTimeDisplay: userData.purchaseTimeDisplay || null,
                            planExpiresOnDisplay: userData.planExpiresOnDisplay || null,
                            timeRemainingSnapshot: userData.timeRemainingSnapshot || null,
                            legacyId: userData.legacyId || null,
                            paymentId: userData.paymentId || null,
                            orderId: userData.orderId || null,
                            amount: userData.amount || null,
                            currency: userData.currency || 'INR',
                            gateway: userData.gateway || null,
                            premiumActive: userData.premiumActive || null,
                            dynamicQrLimit: (userData.plan === 'ultra') ? 30 : ((userData.plan === 'pro') ? 10 : 0)
                        };
                    } else {
                        sub = {
                            plan: 'foundation',
                            status: userData.status || (sub ? sub.status : 'active'),
                            expiresAt: userData.expiresAt || (sub ? sub.expiresAt : null),
                            expiresAtMs: userData.expiresAtMs || (sub ? sub.expiresAtMs : null),
                            purchasedAt: userData.purchasedAt || (sub ? sub.purchasedAt : null),
                            purchasedAtMs: userData.purchasedAtMs || (sub ? sub.purchasedAtMs : null),
                            lastResetAt: prevLastResetAt,
                            resetCount: prevResetCount,
                            lastVerifiedAt: userData.lastVerifiedAt || (sub ? sub.lastVerifiedAt : _isoNow()),
                            dynamicQrLimit: 0
                        };
                    }

                    try {
                        await updateDoc(doc(db, 'users', user.uid), {
                            subscription: sub,
                            plan: deleteField(),
                            status: deleteField(),
                            purchasedAt: deleteField(),
                            purchasedAtMs: deleteField(),
                            expiresAt: deleteField(),
                            expiresAtMs: deleteField(),
                            durationDays: deleteField(),
                            lastVerifiedAt: deleteField(),
                            lastResetAt: deleteField(),
                            resetCount: deleteField(),
                            elevationStatusDisplay: deleteField(),
                            upgradeSequence: deleteField(),
                            userName: deleteField(),
                            planNameDisplay: deleteField(),
                            amountPaidDisplay: deleteField(),
                            priceStr: deleteField(),
                            priceAmount: deleteField(),
                            upgradeDiscountDisplay: deleteField(),
                            discount: deleteField(),
                            purchaseDateDisplay: deleteField(),
                            purchaseTimeDisplay: deleteField(),
                            planExpiresOnDisplay: deleteField(),
                            timeRemainingSnapshot: deleteField(),
                            legacyId: deleteField(),
                            paymentId: deleteField(),
                            orderId: deleteField(),
                            amount: deleteField(),
                            currency: deleteField(),
                            gateway: deleteField(),
                            premiumActive: deleteField()
                        });
                    } catch (cleanErr) {
                        console.warn('[BloomSub] Migration of legacy flat fields failed:', cleanErr);
                    }
                }

                if (!sub || !sub.plan || sub.plan === 'foundation') {
                    _applyFoundation('no_subscription_field');
                    return { plan: 'foundation', source: 'no_subscription_field' };
                }

                const subObj = _buildSubObj(sub);

                // AUTO-EXPIRE: if plan expired on server side, downgrade to foundation
                if (!subObj.isActive && sub.plan !== 'foundation') {
                    console.warn('[BloomSub] Plan expired — auto-downgrading to Foundation');
                    const previousPlan = sub.plan;
                    const newSubData = {
                        plan: 'foundation',
                        status: 'expired_downgrade',
                        expiresAt: sub.expiresAt || null,
                        expiresAtMs: sub.expiresAtMs || null,
                        purchasedAt: sub.purchasedAt || null,
                        purchasedAtMs: sub.purchasedAtMs || null,
                        lastResetAt: _isoNow(),
                        resetCount: (sub.resetCount || 0) + 1,
                        dynamicQrLimit: 0
                    };
                    await setDoc(doc(db, 'users', user.uid), { subscription: newSubData }, { merge: true });
                    await _logHistory(user.uid, 'expired', subObj, previousPlan, 'Auto-downgraded on expiry');

                    if (typeof window.addSuiteNotification === 'function') {
                        window.addSuiteNotification('account', 'Subscription Expired', 'Your subscription expired and your plan has been downgraded to Foundation.', { 'New Plan': 'Foundation', 'Status': 'Expired' });
                    }

                    // Send subscription cancelled/expiry email
                    if (user && user.email) {
                        const emailName = subObj.userName || user.displayName || 'User';
                        const sendCancelEmail = window.sendSubscriptionCancelled || (window.parent && window.parent.sendSubscriptionCancelled);
                        if (typeof sendCancelEmail === 'function') {
                            sendCancelEmail(user.email, emailName)
                                .then(() => console.log('[BloomSub] Auto-expiry cancellation email sent successfully'))
                                .catch(err => console.warn('[BloomSub] Auto-expiry cancellation email failed:', err));
                        }
                    }

                    _applyFoundation('expired');
                    if (typeof pop === 'function') pop('Your plan expired. You have been moved to the Foundation plan.', 'warning');
                    return { plan: 'foundation', source: 'expired' };
                }

                // Plan is valid — apply it
                _applyPlan(subObj, 'firebase_sync');

                // ─── UPDATE DATABASE REMAINING TIME SNAPSHOT ───
                // Recalculate and update the remaining time snapshot in Firestore if needed
                if (subObj.isActive && sub.plan !== 'foundation') {
                    const now = _now();
                    const exMs = subObj.expiresAtMs;
                    if (exMs) {
                        const diffMs = Math.max(0, exMs - now);
                        const diffDays = Math.floor(diffMs / (1000 * 60 * 60 * 24));
                        const diffHours = Math.floor((diffMs % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
                        const diffMinutes = Math.floor((diffMs % (1000 * 60 * 60)) / (1000 * 60));
                        const timeRemainingVal = diffDays > 0 ? `${diffDays}D ${diffHours}H LEFT` : `${diffHours}H ${diffMinutes}M LEFT`;

                        if (sub.timeRemainingSnapshot !== timeRemainingVal) {
                            sub.timeRemainingSnapshot = timeRemainingVal;
                            subObj.timeRemainingSnapshot = timeRemainingVal;
                            try {
                                await updateDoc(doc(db, 'users', user.uid), {
                                    'subscription.timeRemainingSnapshot': timeRemainingVal
                                });
                                console.log('[BloomSub] Updated timeRemainingSnapshot in Firestore:', timeRemainingVal);
                            } catch (err) {
                                console.warn('[BloomSub] Failed to update timeRemainingSnapshot in Firestore:', err);
                            }
                        }
                    }
                }

                // ─── RESTORE ELEVATION DETAILS to localStorage from Firebase ───
                // Restore the current active subscription entry to qr_bloom_purchase_history
                if (sub.legacyId || sub.purchasedAtMs) {
                    _restoreHistoryEntryToLocal(sub);
                }
                // Also restore full history from subscriptionHistory subcollection (background)
                restoreHistoryFromCloud().catch(() => { });

                // console.log(`☁️ [BloomSub] Synced from Firebase — Plan: ${subObj.plan}, Days left: ${subObj.daysLeft}`);
                return { plan: subObj.plan, source: 'firebase', data: subObj };

            } catch (e) {
                console.warn('[BloomSub] Firebase sync failed, using cache:', e.message);
                const cached = _readCache();
                if (cached && cached.isActive) {
                    _applyPlan(cached, 'cache_fallback');
                    return { plan: cached.plan, source: 'cache' };
                }
                _applyFoundation('offline_no_cache');
                return { plan: 'foundation', source: 'offline_no_cache' };
            }
        }

        // ── Save a new subscription to Firebase after payment ──
        // ── Map canonical plan name → display name ──
        const PLAN_DISPLAY_MAP = { 'velocity': 'Velocity', 'quantum': 'Quantum', 'ultra': 'Ultra', 'foundation': 'Foundation', 'max': 'Velocity', 'pro': 'Quantum', 'normal': 'Foundation', 'ultra legend': 'Ultra' };

        async function savePlanToFirebase(paymentData) {
            console.error('[BloomSub] Direct frontend write to Firebase via savePlanToFirebase is disabled for security. Plan activations must go through the secure Cloud Function.');
            return { success: false, error: 'Direct frontend write disabled.' };
        }

        // ── Helper: write/update one entry in qr_bloom_purchase_history from Firebase data ──
        function _restoreHistoryEntryToLocal(subRecord) {
            try {
                const STORAGE_KEY = 'qr_bloom_purchase_history';

                // Build the localStorage entry using EXACT same shape the UI expects
                const entryId = subRecord.legacyId || subRecord.purchasedAtMs || Date.now();
                const entry = {
                    id: entryId,
                    userName: subRecord.userName || 'ELITE USER',
                    planName: subRecord.planNameDisplay || subRecord.plan || 'Foundation',
                    price: subRecord.priceStr || `\u20b9${subRecord.priceAmount || 0}`,
                    discount: subRecord.discount || 0,
                    upgradeSequence: subRecord.upgradeSequence || 1,
                    purchaseDate: subRecord.purchasedAt || (subRecord.purchasedAtMs ? new Date(subRecord.purchasedAtMs).toISOString() : new Date().toISOString()),
                    expiryDate: subRecord.expiresAt || (subRecord.expiresAtMs ? new Date(subRecord.expiresAtMs).toISOString() : new Date().toISOString()),
                    isSynced: true,
                    fromCloud: true,
                    paymentId: subRecord.paymentId || null,
                    orderId: subRecord.orderId || null
                };

                // Always write as single-element array (current plan only, no accumulation)
                const data = JSON.stringify([entry]);
                localStorage.setItem(STORAGE_KEY, data);
                window.dispatchEvent(new CustomEvent('safeStorageChange', { detail: { key: STORAGE_KEY, val: data } }));
                if (typeof window.syncParentSubscription === 'function') window.syncParentSubscription();
            } catch (e) {
                console.warn('[BloomSub] _restoreHistoryEntryToLocal failed:', e);
            }
        }

        // ── Restore current active plan from Firebase (single plan only) ──
        async function restoreHistoryFromCloud() {
            const user = _user();
            if (!user) return;
            try {
                const histSnap = await getDocs(collection(db, 'users', user.uid, 'subscriptionHistory'));
                const records = histSnap.docs.map(d => ({ docId: d.id, ref: d.ref, ...d.data() }));

                // Sort newest first
                records.sort((a, b) => (b.timestampMs || 0) - (a.timestampMs || 0));

                // Only look at valid purchase/upgrade records
                const purchaseRecords = records.filter(r => r.legacyId && (r.action === 'purchased' || r.action === 'upgraded'));

                if (purchaseRecords.length === 0) {
                    // Fallback: restore from users/{uid}/subscription directly
                    const userSnap = await getDocFromServer(doc(db, 'users', user.uid));
                    const userData = userSnap.data();
                    const sub = userData ? userData.subscription : null;
                    if (sub && sub.plan && sub.plan !== 'foundation' && sub.legacyId) {
                        _restoreHistoryEntryToLocal(sub);
                    }
                    return;
                }

                const latest = purchaseRecords[0];

                // Clean up all other history documents except the latest one
                for (const rec of records) {
                    if (rec.docId !== latest.docId) {
                        try {
                            await deleteDoc(rec.ref);
                        } catch (delErr) {
                            console.warn('[BloomSub] Cleanup: Failed to delete older history doc:', delErr);
                        }
                    }
                }

                const STORAGE_KEY = 'qr_bloom_purchase_history';
                const entry = {
                    id: latest.legacyId,
                    userName: latest.userName || 'ELITE USER',
                    planName: latest.planNameDisplay || latest.plan || 'Foundation',
                    price: latest.priceStr || `\u20b9${latest.priceAmount || 0}`,
                    discount: latest.discount || 0,
                    upgradeSequence: latest.upgradeSequence || 1,
                    purchaseDate: latest.purchasedAt || latest.timestamp || (latest.purchasedAtMs || latest.timestampMs ? new Date(latest.purchasedAtMs || latest.timestampMs).toISOString() : new Date().toISOString()),
                    expiryDate: latest.expiresAt || (latest.planExpiresOnDisplay ? new Date(latest.planExpiresOnDisplay).toISOString() : (latest.expiresAtMs ? new Date(latest.expiresAtMs).toISOString() : new Date(Date.now() + 30 * 86400000).toISOString())),
                    isSynced: true,
                    fromCloud: true,
                    paymentId: latest.paymentId || null,
                    orderId: latest.orderId || null
                };

                // Write as single-element array (current plan only)
                const data = JSON.stringify([entry]);
                localStorage.setItem(STORAGE_KEY, data);
                window.dispatchEvent(new CustomEvent('safeStorageChange', { detail: { key: STORAGE_KEY, val: data } }));
                if (typeof window.syncParentSubscription === 'function') window.syncParentSubscription();
            } catch (e) {
                console.warn('[BloomSub] restoreHistoryFromCloud failed:', e);
            }
        }

        // ── Reset plan to Foundation in Firebase ──
        async function resetPlan(reason) {
            const user = _user();
            if (!user) {
                _clearCache();
                localStorage.setItem(PLAN_KEY, 'normal');
                localStorage.removeItem('qr_bloom_purchase_history');
                localStorage.removeItem('premiumActive');
                _applyFoundation('reset_no_login');
                return { success: true, source: 'local_only' };
            }
            try {
                const previousData = getPlanData();
                const previousPlan = previousData.plan;
                const userSnap = await getDocFromServer(doc(db, 'users', user.uid));
                const currentResetCount = (userSnap.exists() && userSnap.data().subscription) ? (userSnap.data().subscription.resetCount || 0) : 0;
                const resetRecord = {
                    plan: 'foundation',
                    status: 'reset',
                    purchasedAt: null,
                    purchasedAtMs: null,
                    expiresAt: null,
                    expiresAtMs: null,
                    durationDays: null,
                    paymentId: null,
                    orderId: null,
                    amount: null,
                    gateway: null,
                    lastResetAt: _isoNow(),
                    resetCount: currentResetCount + 1,
                    lastVerifiedAt: _isoNow(),
                    dynamicQrLimit: 0
                };
                await setDoc(doc(db, 'users', user.uid), { subscription: resetRecord }, { merge: true });
                await _logHistory(user.uid, 'reset', _buildSubObj({ plan: 'foundation', status: 'active', expiresAtMs: 0 }), previousPlan, reason || 'Manual reset');

                if (typeof window.addSuiteNotification === 'function') {
                    window.addSuiteNotification('account', 'Subscription Downgraded', 'Your plan has been reset/downgraded to Foundation.', { 'New Plan': 'Foundation', 'Status': 'Active' });
                }

                // Clear local legacy data
                _clearCache();
                localStorage.removeItem('qr_bloom_purchase_history');
                localStorage.removeItem('premiumActive');
                localStorage.setItem(PLAN_KEY, 'normal');
                window.dispatchEvent(new CustomEvent('safeStorageChange', { detail: { key: 'qr_bloom_purchase_history', val: null } }));

                _applyFoundation('reset');
                if (typeof pop === 'function') pop('Plan reset to Foundation.', 'info');
                return { success: true };
            } catch (e) {
                console.error('[BloomSub] resetPlan failed:', e);
                return { success: false, error: e.message };
            }
        }

        // ── Fetch plan history from Firestore ──
        async function getHistory() {
            const user = _user();
            if (!user) return [];
            try {
                const histSnap = await getDocs(collection(db, 'users', user.uid, 'subscriptionHistory'));
                const records = histSnap.docs.map(d => ({ id: d.id, ...d.data() }));
                records.sort((a, b) => (b.timestampMs || 0) - (a.timestampMs || 0));
                try { localStorage.setItem(HISTORY_CACHE_KEY, JSON.stringify(records)); } catch (e) { }
                return records;
            } catch (e) {
                console.warn('[BloomSub] Failed to fetch history:', e);
                try { return JSON.parse(localStorage.getItem(HISTORY_CACHE_KEY) || '[]'); } catch (e2) { return []; }
            }
        }

        // ── Main entry point: called on login / app start ──
        async function verifyAndApply() {
            const user = _user();
            if (!user) {
                _clearCache();
                _applyFoundation('no_login');
                return;
            }
            await syncFromFirebase();
        }

        // ── Clear local cache (on logout) ──
        async function clearLocalCache() {
            _clearCache();
            localStorage.removeItem(PLAN_KEY);
            localStorage.removeItem('user_subscription');
            localStorage.removeItem('had_premium_plan');
            localStorage.removeItem('dynamic_qr_stats');
            localStorage.removeItem('premiumActive');
            localStorage.removeItem('qr_dynamic');
            localStorage.removeItem('qr_batch_usage');
            localStorage.removeItem('qr_selected_type');
            localStorage.removeItem('qr_total_created');
            localStorage.removeItem('qr_total_decoded');
            localStorage.removeItem('qr_bloom_purchase_history');
            localStorage.removeItem('user_choices');
            localStorage.removeItem('privacy_persistent_choice');
            localStorage.removeItem('app_lock_config');
            localStorage.removeItem('qrbloom_scanned_dyn_qrs');
            localStorage.removeItem('qr_bloom_watermark_config');
            localStorage.removeItem('last_notified_subscription');
            localStorage.removeItem('userStoreEnc');
            localStorage.setItem('current_suite_view', 'landing');

            window.dispatchEvent(new CustomEvent('safeStorageChange', { detail: { key: 'qr_dynamic', val: '0' } }));
            window.dispatchEvent(new CustomEvent('safeStorageChange', { detail: { key: 'qr_batch_usage', val: '0' } }));
            window.dispatchEvent(new CustomEvent('safeStorageChange', { detail: { key: 'qr_total_created', val: '0' } }));

            if (window.QRHistoryDB && typeof window.QRHistoryDB.clearStore === 'function') {
                try {
                    await window.QRHistoryDB.clearStore('creator_history');
                    await window.QRHistoryDB.clearStore('decoder_history');
                } catch (e) {
                    console.error("[BloomSub] Failed to clear IndexedDB stores:", e);
                }
            }

            if (typeof renderHistory === 'function') renderHistory();
            if (typeof renderVaultHistory === 'function') renderVaultHistory();
            if (typeof updateHistoryUI === 'function') updateHistoryUI();
        }

        // ── Expose public API ──
        return {
            getActivePlan,
            getPlanData,
            isPlanActive,
            getDaysRemaining,
            getTimeLeftString,
            syncFromFirebase,
            savePlanToFirebase,
            resetPlan,
            getHistory,
            restoreHistoryFromCloud,
            verifyAndApply,
            clearLocalCache
        };
    })(),
    writable: false, configurable: false
});

// console.log('🔐 [BloomSub] Subscription Manager initialized.');

// ── Listen for bloomPlanChanged to sync legacy keys ──
window.addEventListener('bloomPlanChanged', (e) => {
    if (e.detail && e.detail.plan) {
        // Ensure parent-level syncParentSubscription stays in sync
        if (typeof window.syncParentSubscription === 'function') {
            window.syncParentSubscription();
        }
    }
});

// 15-MINUTE SECURITY HEARTBEAT (also verifies subscription)
setInterval(() => {
    window.syncProfileWithCloud();
    if (window.BloomSubscription && auth.currentUser) {
        window.BloomSubscription.syncFromFirebase();
    }
}, 15 * 60 * 1000);

// Google One Tap Sign-In Integration
async function handleGoogleOneTapResponse(response) {
    try {
        if (typeof pop === 'function') pop("Google One Tap: Authenticating...", "info");
        const credential = GoogleAuthProvider.credential(response.credential);
        const result = await signInWithCredential(auth, credential);
        const profileData = await syncGoogleUserProfile(result.user);
        
        if (window.BloomSubscription) {
            window.BloomSubscription.syncFromFirebase();
        }

        if (typeof pop === 'function') pop(`Logged in securely as ${profileData.first || 'User'}`, "success");
        
        // Trigger UI/SPA view updates
        const activeLayer = localStorage.getItem('active_layer_mode') || '1';
        window.dispatchEvent(new CustomEvent('safeStorageChange', { detail: { key: 'active_layer_mode', val: activeLayer } }));
        
        // Close SPA / login overlay if active
        if (typeof closeSPA === 'function') closeSPA();
        
    } catch (error) {
        console.error("Google One Tap authentication failed:", error);
        if (window.bloomAnalytics) {
            window.bloomAnalytics.logAuthAction('login_failure', 'google_one_tap');
            window.bloomAnalytics.logError(error.message, 'google_one_tap');
        }
        if (typeof pop === 'function') pop("Authentication failed: " + error.message, "error");
    }
}

let oneTapInitialized = false;

function initGoogleOneTap() {
    if (oneTapInitialized) return;
    
    if (typeof google === 'undefined' || !google.accounts || !google.accounts.id) {
        setTimeout(initGoogleOneTap, 1000);
        return;
    }
    
    try {
        google.accounts.id.initialize({
            client_id: "642784248397-t7l1buq31qd720g0pdd8kcdq1sblkcjh.apps.googleusercontent.com",
            callback: handleGoogleOneTapResponse,
            auto_select: false,
            cancel_on_tap_outside: false
        });

        google.accounts.id.prompt((notification) => {
            if (notification.isNotDisplayed()) {
                console.log("One Tap not displayed:", notification.getNotDisplayedReason());
            } else if (notification.isSkippedMoment()) {
                console.log("One Tap skipped:", notification.getSkippedReason());
            } else if (notification.isDismissedMoment()) {
                console.log("One Tap dismissed:", notification.getDismissedReason());
            }
        });
        
        oneTapInitialized = true;
    } catch (e) {
        console.error("Error initializing Google One Tap:", e);
    }
}

// Persistence & Sync Listener
onAuthStateChanged(auth, async (user) => {
    if (user) {
        // Check if account switch occurred
        const lastUid = localStorage.getItem('last_active_uid');
        if (lastUid && lastUid !== user.uid) {
            console.warn("⚠️ Sync Alert: User switch detected. Clearing previous user cache.");
            localStorage.removeItem('userStoreEnc');
            if (window.BloomSubscription) {
                await window.BloomSubscription.clearLocalCache();
            }
            ['dynamic_qr_stats', 'had_premium_plan', 'qr_batch_usage', 'qr_dynamic', 'qr_selected_type', 'qr_total_created', 'qr_total_decoded', 'qrbloom_scanned_dyn_qrs', 'user_subscription'].forEach(k => {
                try { localStorage.removeItem(k); } catch (e) {}
            });
            window.dispatchEvent(new CustomEvent('safeStorageChange', { detail: { key: 'user_subscription', val: 'foundation' } }));
        }
        localStorage.setItem('last_active_uid', user.uid);

        if (localStorage.getItem('explicit_logout') === 'true') {
            if (window.userSnapshotListener) {
                try { window.userSnapshotListener(); } catch (e) { }
                window.userSnapshotListener = null;
            }
            await signOut(auth);
            return;
        }

        window.syncProfileWithCloud();
        // Verify subscription from Firebase on every login
        if (window.BloomSubscription) {
            window.BloomSubscription.verifyAndApply();
        }

        if (window.userSnapshotListener) window.userSnapshotListener();
        window.userSnapshotListener = onSnapshot(doc(db, "users", user.uid), (snapshot) => {
            if (snapshot.exists()) {
                const freshData = snapshot.data();
                delete freshData.password;
                delete freshData.confirm;

                // Prevent local optimistic role spoofing/flashes until server confirms it
                if (snapshot.metadata.hasPendingWrites && freshData.role === 'owner') {
                    const currentLocal = window.userData || {};
                    freshData.role = currentLocal.role || 'user';
                }

                freshData.isVerified = true;

                if (freshData.subscription && window.BloomSubscription) {
                    window.BloomSubscription.syncFromFirebase();
                }

                if (freshData.qr_batch_usage !== undefined && freshData.qr_batch_usage !== null) {
                    window._qrbloom_batch_usage = parseInt(freshData.qr_batch_usage) || 0;
                } else {
                    window._qrbloom_batch_usage = 0;
                }
                try { localStorage.removeItem('qr_batch_usage'); } catch(e) {}

                if (freshData.qr_dynamic !== undefined && freshData.qr_dynamic !== null) {
                    window._qrbloom_dynamic_usage = parseInt(freshData.qr_dynamic) || 0;
                } else {
                    window._qrbloom_dynamic_usage = 0;
                }
                try { localStorage.removeItem('qr_dynamic'); } catch(e) {}

                const oldDataStr = JSON.stringify(window.userData);
                const newDataStr = JSON.stringify(freshData);

                window.userData = freshData;

                const encrypted = CryptoJS.AES.encrypt(JSON.stringify(freshData), _getAppSecret()).toString();
                localStorage.setItem('userStoreEnc', encrypted);

                if (typeof updateMomentumDash === 'function') updateMomentumDash();
                if (typeof updateAvatarUI === 'function') updateAvatarUI();

                // Check inside settings.app_lock_config, settings.mobile.app_lock_config, or app_lock_config
                let cloudConfig = (freshData.settings && freshData.settings.app_lock_config) ||
                    (freshData.settings && freshData.settings.mobile && freshData.settings.mobile.app_lock_config) ||
                    freshData.app_lock_config || null;

                // If user has local app lock but no cloud app lock, sync local to cloud
                if (!cloudConfig && window._0x83e2 && window._0x83e2.config) {
                    try {
                        const localConfig = window._0x83e2.config;
                        // Merge it into freshData and trigger sync
                        freshData.app_lock_config = localConfig;
                        cloudConfig = localConfig;
                        window.syncProfileWithCloud();
                    } catch (e) {
                        console.error("Error migrating local App Lock config to cloud", e);
                    }
                }

                if (window._0x83e2) {
                    const configChanged = JSON.stringify(window._0x83e2.config) !== JSON.stringify(cloudConfig);
                    if (configChanged) {
                        window._0x83e2.config = cloudConfig;
                        window._0x83e2.checkAppLock();
                    }
                }
                if (cloudConfig) {
                    localStorage.removeItem('app_lock_config');
                }

                // Fetch Mobile Settings from user profile document (migrated from settings or settings.mobile or mobile)
                let ms = null;
                if (freshData.settings) {
                    if (freshData.settings.mobile) {
                        ms = freshData.settings.mobile;
                    } else {
                        const hasKeys = Object.keys(freshData.settings).some(k => k.startsWith('suite_') || k === 'active_layer_mode' || k === 'font');
                        if (hasKeys) {
                            ms = freshData.settings;
                        }
                    }
                }
                if (!ms && freshData.mobile) {
                    ms = freshData.mobile;
                }
                if (ms) {
                    // Only apply cloud settings if no local setting sync is active or pending write
                    const isPending = isSettingsSyncPending || (snapshot.metadata && snapshot.metadata.hasPendingWrites);
                    if (!isPending) {
                        // 1. Resolve Font Mode / Font Name
                        let fontMode = null;
                        if (ms.active_layer_mode !== undefined && ms.active_layer_mode !== null) {
                            fontMode = String(ms.active_layer_mode);
                        } else if (ms.font !== undefined && ms.font !== null) {
                            const fontVal = String(ms.font).trim();
                            if (FONT_MAP[fontVal]) {
                                fontMode = fontVal;
                            } else {
                                fontMode = REVERSE_FONT_MAP[fontVal] || "1";
                            }
                        }

                        if (fontMode) {
                            if (localStorage.getItem('active_layer_mode') !== fontMode) {
                                if (window.safeStorage) {
                                    window.safeStorage.setItem('active_layer_mode', fontMode, true);
                                } else {
                                    localStorage.setItem('active_layer_mode', fontMode);
                                    window.dispatchEvent(new CustomEvent('safeStorageChange', { detail: { key: 'active_layer_mode', val: fontMode, isRemote: true } }));
                                }
                            }
                            // Force apply the font mode to the UI
                            const parsedMode = parseInt(fontMode);
                            if (!isNaN(parsedMode)) {
                                window.syncFontMode(parsedMode);
                            }
                        }

                        // 2. Resolve all other keys
                        Object.entries(ms).forEach(([key, val]) => {
                            if (key === 'font' || key === 'active_layer_mode') return; // Handled above
                            if (localStorage.getItem(key) !== String(val)) {
                                if (window.safeStorage) {
                                    window.safeStorage.setItem(key, val, true);
                                } else {
                                    localStorage.setItem(key, val);
                                    window.dispatchEvent(new CustomEvent('safeStorageChange', { detail: { key, val, isRemote: true } }));
                                }
                            }
                        });
                    }
                }

                const iframes = document.querySelectorAll('iframe');
                iframes.forEach(iframe => {
                    try {
                        if (iframe.contentWindow) {
                            iframe.contentWindow.userData = freshData;

                            if (typeof iframe.contentWindow.updateMomentumDash === 'function') {
                                iframe.contentWindow.updateMomentumDash();
                            }
                            if (typeof iframe.contentWindow.updateAvatarUI === 'function') {
                                iframe.contentWindow.updateAvatarUI();
                            }
                        }
                    } catch (e) { }
                });

                if (oldDataStr !== newDataStr) {
                    if (typeof pop === 'function') pop("Security Sync: Profile Updated from Cloud", "success");
                }
            }
        }, (error) => {
            console.error("Snapshot error:", error);
        });
    } else {
        localStorage.removeItem('last_active_uid');
        const isExplicitLogout = localStorage.getItem('explicit_logout') === 'true';
        if (isExplicitLogout) {
            console.warn("⚠️ Sync Alert: Cleaning up local session per logout request.");
            localStorage.removeItem('userStoreEnc');
            localStorage.removeItem('explicit_logout');
            // Clear plan cache on logout → revert to foundation
            if (window.BloomSubscription) {
                await window.BloomSubscription.clearLocalCache();
            }
            ['dynamic_qr_stats', 'had_premium_plan', 'qr_batch_usage', 'qr_dynamic', 'qr_selected_type', 'qr_total_created', 'qr_total_decoded', 'qrbloom_scanned_dyn_qrs', 'user_subscription'].forEach(k => {
                try { localStorage.removeItem(k); } catch (e) {}
            });
            window.dispatchEvent(new CustomEvent('safeStorageChange', { detail: { key: 'user_subscription', val: 'foundation' } }));
            if (typeof closeSPA === 'function') closeSPA();
        } else {
            // Trigger Google One Tap Sign-In automatically if not logged in
            initGoogleOneTap();
        }
    }
    if (typeof updateTelemetryStats === 'function') updateTelemetryStats();
    if (typeof loadDensityStats === 'function') loadDensityStats();
    if (typeof updateSandboxData === 'function') updateSandboxData();
});

// Bridge Logout Enhancement: Ensure persistence is cleared across reloads
const originalLogout = window.suiteAuthBridge.logout;
window.suiteAuthBridge.logout = async () => {
    localStorage.setItem('explicit_logout', 'true');
    const result = await originalLogout();
    if (result.success) {
        localStorage.removeItem('userStoreEnc');
        sessionStorage.clear();
        // Clear plan cache — user must re-login to restore plan
        if (window.BloomSubscription) {
            await window.BloomSubscription.clearLocalCache();
        }
        ['dynamic_qr_stats', 'had_premium_plan', 'qr_batch_usage', 'qr_dynamic', 'qr_selected_type', 'qr_total_created', 'qr_total_decoded', 'qrbloom_scanned_dyn_qrs', 'user_subscription'].forEach(k => {
            try { localStorage.removeItem(k); } catch (e) {}
        });
        window.dispatchEvent(new CustomEvent('safeStorageChange', { detail: { key: 'user_subscription', val: 'foundation' } }));
    }
    return result;
};

// GLOBAL DEBOUNCED SETTINGS SYNC FOR MOBILE
const SYNCCABLE_KEYS = [
    'suite_sound_muted', 'suite_sound_volume',
    'suite_typing_enabled', 'suite_typing_volume', 'suite_typing_tune',
    'suite_bottom_nav_enabled', 'suite_bottom_nav_volume',
    'nav_anim_enabled', 'active_layer_mode',
    'session_protocol_enabled', 'fullscreen_on_click'
];

window.addEventListener('safeStorageChange', (e) => {
    if (e.detail && e.detail.isRemote) return;

    if (e.detail && SYNCCABLE_KEYS.includes(e.detail.key)) {
        isSettingsSyncPending = true;
        if (settingsSyncTimeout) clearTimeout(settingsSyncTimeout);

        // Sync session protocol instantly
        if (e.detail.key === 'session_protocol_enabled') {
            if (window.suiteAuthBridge && typeof window.suiteAuthBridge.pushSettingsToCloud === 'function') {
                window.suiteAuthBridge.pushSettingsToCloud();
            }
        } else {
            settingsSyncTimeout = setTimeout(async () => {
                settingsSyncTimeout = null;
                if (window.suiteAuthBridge && typeof window.suiteAuthBridge.pushSettingsToCloud === 'function') {
                    await window.suiteAuthBridge.pushSettingsToCloud();
                }
            }, 500);
        }
    }
});